import React from 'react';
import './WhatIsSBRaint.css';

const WhatIsSBRaint = () => {
  return (
    <div className="what-is-sbraint">
      <h2>WHAT IS SBRAINT</h2>
      <h3>Super Brain Tech Inc.</h3>
      <div className="steps">
        <div className="step">
          <h4>01</h4>
          <h5>Imagine</h5>
          <p>The super-brain generates vivid experiences from its own complex thoughts.</p>
        </div>
        <div className="step">
          <h4>02</h4>
          <h5>Brain Freeze</h5>
          <p>Storytelling that surprises and overwhelms, shattering norms and leaving audiences briefly awestruck.</p>
        </div>
        <div className="step">
          <h4>03</h4>
          <h5>Repeat</h5>
          <p>Generates experiences that are consistently engaging, allowing for enjoyable repeated interactions.</p>
        </div>
      </div>
    </div>
  );
};

export default WhatIsSBRaint;
